export const PRESET_DURATIONS = [60, 120];
export const CUSTOM_DURATION = 135;
